import { Vue, Component, Ref } from 'vue-property-decorator'
import { ICellEditorComp } from '@ag-grid-enterprise/all-modules'
import {
    initialNumericCellEditorState,
    NumericCellEditorParams,
    NumericCellEditorState
} from '@/cellEditors/numeric/numeric-cell-editor.model'

@Component
export default class NumericCellEditor extends Vue implements ICellEditorComp {
    protected params!: NumericCellEditorParams // initialized by ag-grid
    @Ref() readonly input!: any

    state: NumericCellEditorState
    constructor() {
        super()
        this.state = initialNumericCellEditorState()
    }

    get maxLength(): number | undefined {
        return this.params.max?.toString().length
    }

    get step(): number {
        return this.params.step ?? 1
    }

    /// VUE HOOKS ///

    created(): void {
        this.state.value = this.params.value
    }

    mounted(): void {
        this.focus()
    }

    /// AG-GRID CELL EDITOR ///

    getGui(): HTMLElement {
        return this.input
    }

    getValue(): NumericCellEditorState['value'] {
        return this.state.value
    }

    isCancelAfterEnd(): boolean {
        return !!this.state.value && (
            (!!this.params.min && this.state.value < this.params.min) ||
            (!!this.params.max && this.state.value > this.params.max)
        )
    }

    /// METHODS ///

    focus(): void {
        this.input.focus()
    }
}
